module.exports = __webpack_public_path__ + "img/prize-02.ba9f3a4e.png";